class NestedMegaMenuNav extends HTMLElement {
  connectedCallback() {
    this.level2Items = this.querySelectorAll('.mega-menu__link--level-2')
    this.level3Panels = this.querySelectorAll('.mega-menu__level-3-wrapper')
    this.addEventListener('mouseover', this.onMouseOver.bind(this))

    // Listen for each dropdown <details> opening
    this.querySelectorAll('details.mega-menu').forEach((detailsEl) => {
      detailsEl.addEventListener('toggle', () => {
        if (detailsEl.open) {
          const firstItem = detailsEl.querySelector('.mega-menu__link--level-2')
          const key = firstItem?.dataset.key
          if (key) this.setActive(key)
        }
      })
    })
  }

  onMouseOver(event) {
    const item = event.target.closest('.mega-menu__link--level-2')
    if (!item || !this.contains(item)) return

    const key = item.dataset.key
    this.setActive(key)
  }

  setActive(key) {
    this.level2Items.forEach((item) => {
      item.classList.toggle('active', item.dataset.key === key)
      item.setAttribute('aria-selected', item.dataset.key === key)
    })

    this.level3Panels.forEach((panel) => {
      panel.hidden = panel.dataset.key !== key
    })
  }
}

customElements.define('nested-mega-menu-nav', NestedMegaMenuNav)
